export const GRADIENT_1 = "bg-gradient-to-r from-brand-nine to-brand-ten"
